
const Styles = theme => ({
  title: {
    color: '#f3bf38',
  }
});

export default Styles